module.exports = __webpack_public_path__ + "static/media/icon-seguranca.cbf6b1ad.svg";